import { useFormContext } from 'react-hook-form';

import { useTranslations } from '@lang';
import { NotesField } from '../../../components/NotesField';

import { FormBox, TableFormContainer } from '../../../components/TableForm/TableForm.styles';
import { PackagesFormValues, TablesSchema } from '../../../types';
import { PageTitle } from '../../FormSteps.styles';
import { useStepFooter } from '../../hooks/useStepFooter';
import { DiningOption } from '../DiningOption/DiningOption';
import { TablesContainer, TablesWrapper } from '../TablesStep.styles';
import { Fragment } from 'react';
import { usePackageConfiguration, useWizardNavigation } from '../../../contexts';

export const MultiDayTablesStep = () => {
  const { room } = usePackageConfiguration();
  const { currentFormStep } = useWizardNavigation();

  const { watch } = useFormContext<PackagesFormValues>();
  const { t } = useTranslations();
  const tables = watch('tables');
  const isValid = TablesSchema.safeParse(tables).success;

  const footer = useStepFooter({ isValid, titleSuffix: room.name });

  const currentStep = currentFormStep;
  const allDiningOptions = currentStep.diningOptions || [];

  return (
    <TablesWrapper>
      <TablesContainer>
        <PageTitle>{t('flynav.dining')}</PageTitle>
        <TableFormContainer>
          {allDiningOptions.map((diningOption, index) => (
            <Fragment key={`dining-${diningOption.id}-${index}`}>
              <FormBox>
                <DiningOption option={diningOption} optionIndex={index} />
              </FormBox>
            </Fragment>
          ))}
          <FormBox>
            <NotesField name="tables.notes" label={t('tables.notes')} />
          </FormBox>
        </TableFormContainer>
        {footer}
      </TablesContainer>
    </TablesWrapper>
  );
};
